import { Accordion, Alert, Text } from "@oysterhr/ui"
import { Trans, useTranslation } from "react-i18next"

export const PrimaryDutyPearlContent = () => {
  const { t } = useTranslation("knowledge_base/HiringAdvisor", {
    keyPrefix: "roleInformation.primaryDuty",
  })

  return (
    <div>
      <Text>
        <Trans defaults={t("header")} components={{ br: <br /> }} />
      </Text>
      <Accordion className="mt-8">
        <Accordion.Item>
          <Accordion.Button className="w-full">{t("examples.header")}</Accordion.Button>
          <Accordion.Content>
            <ul className="list-disc pl-4">
              <li>
                <Text>
                  <Trans
                    as="span"
                    defaults={t("examples.item1")}
                    components={{ strong: <Text className="inline font-semibold" /> }}
                  />
                </Text>
              </li>
              <li>
                <Text>
                  <Trans
                    as="span"
                    defaults={t("examples.item2")}
                    components={{ strong: <Text className="inline font-semibold" /> }}
                  />
                </Text>
              </li>
              <li>
                <Text>
                  <Trans
                    as="span"
                    defaults={t("examples.item3")}
                    components={{ strong: <Text className="inline font-semibold" /> }}
                  />
                </Text>
              </li>
            </ul>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion>
      <Alert className="mt-8">
        <Alert.Icon />
        <Alert.Heading>{t("alert.header")}</Alert.Heading>
        <Alert.Content>
          <ul className="list-disc">
            <li>{t("alert.item1")}</li>
            <li>{t("alert.item2")}</li>
          </ul>
        </Alert.Content>
      </Alert>
    </div>
  )
}
